module.exports = __webpack_public_path__ + "img/btn_GDV_live.8b869922.svg";